import { orientationModuleAssignmentService } from '@/services/api/orientationModuleAssignment.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { orientationModuleAssignmentModel } from '@/models/api/orientationModuleAssignment.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const ORIENTATION_MODULE_ASSIGNMENT_MODULE = "api/orientationModuleAssignment";

// ACTIONS
export const GET_ALL_ORIENTATION_MODULE_ASSIGNMENT = 'getAllOrientationModuleAssignment';
export const CREATE_ORIENTATION_MODULE_ASSIGNMENT = 'createOrientationModuleAssignment';
export const GET_ORIENTATION_MODULE_ASSIGNMENT = 'getOrientationModuleAssignment';
export const UPDATE_ORIENTATION_MODULE_ASSIGNMENT = 'updateOrientationModuleAssignment';
export const UPDATE_ORIENTATION_MODULE_ASSIGNMENT_STATUS = 'updateOrientationModuleAssignmentStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_ORIENTATION_MODULE_ASSIGNMENT_SUCCESS = "allOrientationModuleAssignmentSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_ORIENTATION_MODULE_ASSIGNMENT_SUCCESS = "getOrientationModuleAssignmentSuccess";

export const actions = {
    [GET_ALL_ORIENTATION_MODULE_ASSIGNMENT]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        orientationModuleAssignmentService
            .getAll(filter)
            .then((result) => {
                commit(ALL_ORIENTATION_MODULE_ASSIGNMENT_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_ORIENTATION_MODULE_ASSIGNMENT]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return orientationModuleAssignmentService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_ORIENTATION_MODULE_ASSIGNMENT, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_ORIENTATION_MODULE_ASSIGNMENT]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return orientationModuleAssignmentService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_ORIENTATION_MODULE_ASSIGNMENT_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_ORIENTATION_MODULE_ASSIGNMENT]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return orientationModuleAssignmentService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_ORIENTATION_MODULE_ASSIGNMENT, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_ORIENTATION_MODULE_ASSIGNMENT_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return orientationModuleAssignmentService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_ORIENTATION_MODULE_ASSIGNMENT, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_ORIENTATION_MODULE_ASSIGNMENT_SUCCESS](state, {data}) {
        let orientationModuleAssignmentList = data.data || [];
        state.list.data = orientationModuleAssignmentList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = orientationModuleAssignmentList.map(item => orientationModuleAssignmentModel(item));
        }
    },
    [GET_ORIENTATION_MODULE_ASSIGNMENT_SUCCESS](state, data) {
        state.details = orientationModuleAssignmentModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
